import { render, staticRenderFns } from "./add-field-modal.vue?vue&type=template&id=6895e4f1&"
import script from "./add-field-modal.vue?vue&type=script&lang=js&"
export * from "./add-field-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-field-modal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports